import { Alert, AlertTitle } from "@material-ui/lab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";

import TabPanel from "@mui/lab/TabPanel";
import { Box } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Tab from "@mui/material/Tab";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { IReduxState } from "../store";
import { IReduxState } from "../store";
import Services from "./Services";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../util/apiClient";
import { anneescolaire } from "../util/constant";
import { setEtabActivetedWebService, setFetchingData, setFilteredEtabActivetedWebService } from "../store/xserverSlice";
import { IEtabActivetedWebService } from "./Services/interface";


function GestionServiceXserver() {
  //redux
  const dispatch = useDispatch();

  // hooks
  const [value, setValue] = React.useState("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };


  const getListeXserverService = async () => {
    try {
      dispatch(setFetchingData(true))
      // const res = await apiClient.get(ADMIN_SERVER_BASE_URL, `/tablesystem/getetabsactivetedwebservice/2023-2024`)
      const res = await apiClient.get(ADMIN_SERVER_BASE_URL, `/tablesystem/getetabsactivetedwebservice/${anneescolaire}`)
      if (res.status === 1) {
        console.log("🚀 ~ getListeXserverService ~ res.data:", res.data)
        // ✅ filtrer uniquement les établissements avec un codeEtab à 6 chiffres
        const filtered = res.data.filter(
          (item: IEtabActivetedWebService) => /^\d{6}$/.test(item.codeEtab)
        );
        dispatch(setEtabActivetedWebService(filtered));
        dispatch(setFilteredEtabActivetedWebService(filtered));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:38 ~ getListeXserverService ~ error:", error)
    } finally {
      dispatch(setFetchingData(false))
    }
  };

  useEffect(() => {
    getListeXserverService()
  }, [])


  return (
    <div>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>

            <TabList
              onChange={handleChange}
              variant="scrollable"
              scrollButtons
            >
              <Tab label="Web services" value="1" />
            </TabList>
          </Box>

          <TabPanel value="1">
            <Services />
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  );
}

export default GestionServiceXserver;
